import { ScrollButtons } from 'thalia-elements/modules/lists/scroll-buttons/main.js';

class SliderLogos extends HTMLElement {
    constructor() {
        super();
        this.scrollButtons = null;
        this.sprungMarke = this.dataset.slidePush;
    }

    connectedCallback() {
        const liste = this.querySelector('.logo-list');
        if (!liste) {
            return;
        }
        this.scrollButtons = new ScrollButtons(liste);
        this.scrollButtons.init();
    }

    disconnectedCallback() {
        this.scrollButtons?.destroy();
    }
}

if (!customElements.get('slider-logos')) {
  customElements.define('slider-logos', SliderLogos);
}
